import { toast } from '@artic/ui/toast';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { subscribeAccessDeniedToast, takePendingAccessDeniedToast } from './route-guard';

/**
 * Fires the access-denied toast queued by the root route guard. Render it
 * inside the I18nProvider (so the copy is loaded). The toast is deferred a
 * macrotask so the sibling <Toaster>, whose subscribing effect runs later in
 * the same commit, is listening — sonner drops toasts sent before that.
 */
export function AccessDeniedToast() {
  const { t } = useTranslation('common');
  const message = t('navigation.sectionAccessDenied');

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const show = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (takePendingAccessDeniedToast()) {
          toast.error(message, { id: 'section-access-denied' });
        }
      }, 0);
    };
    show();
    const unsubscribe = subscribeAccessDeniedToast(show);
    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, [message]);

  return null;
}
